import { styled } from 'styled-components';
import { ScSectionTitle } from '@/components/SectionTitle/styled';
import {
  ScCategoriesWrapper,
  ScTabNavigation,
} from '@/components/TabNavigation/styled';
import { containerPadding, screen, typography } from '@/styles/helpers';

export const ScBonusShopPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  ${ScCategoriesWrapper} > .mob-full {
    left: -${containerPadding.base}px;
    width: calc(100% + ${containerPadding.base * 2}px);

    @media (${screen.md}) {
      left: 0;
      width: 100%;
    }
  }

  ${ScTabNavigation} {
    padding-left: ${containerPadding.base}px;

    @media (${screen.md}) {
      padding-left: 0;
    }
  }

  & > .heading {
    container: bonus-shop-heading / inline-size;
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  & .sections {
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  & .tab-section {
    display: flex;
    flex-direction: column;
    gap: 16px;

    ${ScSectionTitle} {
      margin-bottom: 0;
      text-transform: none;
    }
  }

  & .products-grid {
    display: grid;
    grid-template-rows: repeat(2, auto);
    grid-auto-flow: column;
    grid-auto-columns: 232px;
    gap: 12px;
    overflow-x: auto;
    margin-inline: -${containerPadding.base}px;
    padding-inline: ${containerPadding.base}px;

    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    }

    @media (${screen.md}) {
      grid-template-rows: none;
      grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
      grid-auto-flow: row;
      grid-auto-columns: auto;
      gap: 16px;
      overflow-x: visible;
      margin-inline: 0;
      padding-inline: 0;
    }
  }
`;

export const ScBonusShopGuestCta = styled.div`
  display: flex;
  justify-content: center;

  & button {
    width: 250px;
    height: 48px;
  }
`;

export const ScBonusShopNotice = styled.div`
  width: 100%;
  max-width: 608px;
  margin-inline: auto;

  &:empty {
    display: none;
  }
`;

export const ScBonusShopTitle = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.whiteColor};
  text-transform: uppercase;
  ${typography.headline2}

  @media (${screen.md}) {
    ${typography.headline1}
  }
`;
